import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

/**
 * Company-scoped checklist (srg.checklist). Agency-owned; list/create use company ID.
 */
@Injectable({ providedIn: 'root' })
export class CompanyChecklistService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/checklists`);
  }

  importFromDefaults(templateIds: number[], urlParams: any = {}) {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/checklists/import_from_defaults`, urlParams);
    return this.http.post<{ imported_ids: number[]; count: number }>(url, { template_ids: templateIds });
  }
}
